<app-customer-detail *ngIf="!couponId" [businessId]="businessId"></app-customer-detail>
<app-product-coupon-vip-content *ngIf="couponId"></app-product-coupon-vip-content>

